import * as React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import { Dashboard } from './dashboard';
import Register from './layout/Register';
import AccountClosure from "./layout/AccountClosure"
import HomeValuation from "./layout/HomeValuation"
import AddressAndCreditReport from './layout/AddressAndCreditReport';
import PullCreditFile from './layout/pullCreditFile';
import UserDetail from './layout/userDetail';
import UserInflightDetails from './layout/UserInflightDetails';
import TransferRewardAmount from './layout/transferRewardAmount';
import RedisCacheCleaner from './layout/RedisCacheCleaner';
import PpsPayee from './layout/PpsPayee';
import UpadtePayToLender from './layout/updatePayToLender';
import UpdatePendingTask from './layout/updatePendnigTask';
import UpdateUserPendingAction from './layout/updateUserPendingAction';
import ApplyPromoReferralCode from './layout/ApplyPromoReferralCode';

import DeleteUser from './layout/DeleteUser';
import ManageUser from './layout/ManageUser';
import PNNotifier from './layout/PNNotifier';
import MasterToEwalletFailure from './layout/MasterToEwalletFailure';
import PromoCodeRecords from './layout/PromoCodeRecords';
import UpadteDirectDebit from './layout/updateDirectDebit';
import GetVerificationLink from './layout/GetVerificationLink';
import GiftCardDashboard from './layout/GiftCardDashboard';
import UpdateGiftCardBlacklist from './layout/updateGiftCardBlacklist';
import RemortgageLetter from './layout/RemortgageLetter';
import GenerateBrokerReport from './layout/GenerateBrokerReport';
import RemoveUserFromSuppressionList from './layout/RemoveUserFromSuppressionList';
import RemovePinForUser from './layout/RemovePinForUser';
import ForcedLogutUser from './layout/ForceLogoutUser';
import UserMortgageData from './layout/UserMortgageData';
import ChangeGiftCardState from './layout/ChangeGiftCardState';
import CreatePromocode from './layout/CreatePromocode';
import AccountRestore from './layout/AccountRestore';
import TrueLayerSyncFailureMonitor from './layout/TrueLayerSyncFailureMonitor';
import DupeAccountCheck from './layout/DupeAccountCheck';
import AmlChecks from './layout/AmlChecks';
import DeleteVrpConsent from './layout/DeleteVrpConsent';
import SuperchargedCalculator from './layout/SuperchargedCalculator';
import GiftCardTransactionDetailsPage from './layout/GiftCardTransactionDetailsPage';
import GiftCardTopupsDashboard from './layout/GiftCardTopupsDashboard';
import VdxDashboard from './layout/vdxDashboard';
import PartnerizeUserActivity from './layout/partnerizeUserActivity';
import AwinUserActivity from './layout/awinUserActivity';
import AffiliateUserActivity from './layout/affiliateUserActivity';
import FeatureFlagDashboard from './layout/FeatureFlagDashboard';
import PaymentProviderDashboard from './layout/PaymentProviderDashboard';
import UpdateUser from './layout/UpdateUser';
import MoveAccountRewards from './layout/MoveAccountRewards';
import RemoveBiometricsForUser from './layout/RemoveBiometricsForUser';
import ManageUserPasskeys from './layout/ManageUserPasskeys';
import ManageDeviceSignatures from './layout/ManageDeviceSignatures';
import MortgageKycDebug from './layout/MortgageKycDebug';
import MasterToUserWalletDashboard from './layout/MasterToUserWalletDashboard';
import NatwestTransferDashboard from './layout/NatwestTransferDashboard';
import TilloFloatDashboard from './layout/TilloFloatDashboard';
import NatwestInternalTransferDashboard from './layout/NatwestInternalTransferDashboard';
import NeoCurrencyTopupDashboard from './layout/NeoCurrencyTopupDashboard';
import ReferralConfig from './layout/ReferralConfig';
import ReferralUserTracking from './layout/ReferralUserTracking';
import ReferralFraudReview from './layout/ReferralFraudReview';
import BrandHaircutConfig from './layout/BrandHaircutConfig';
import GiftCardBrands from './layout/GiftCardBrands';
import GiftCardBrandManagement from './layout/GiftCardBrandManagement';
import BrandCatalogVdxMerchants from './layout/BrandCatalogVdxMerchants';
import BrandCatalogTilloHealth from './layout/BrandCatalogTilloHealth';
import BrandCatalogTilloOverride from './layout/BrandCatalogTilloOverride';
import PromoBannerConfig from './layout/PromoBannerConfig';
import ReferralPromoBannerConfig from './layout/ReferralPromoBannerConfig';
import PrizeDrawConfig from './layout/PrizeDrawConfig';
import VdxMerchantsDashboard from './layout/VdxMerchantsDashboard';
import PartnerizeBrandsDashboard from './layout/PartnerizeBrandsDashboard';
import AwinBrandsDashboard from './layout/AwinBrandsDashboard';
import VdxBrandUrlTest from './layout/VdxBrandUrlTest';
import VdxClaimForm from './layout/VdxClaimForm';
import CancelVoucherList from './cancelVoucher/CancelVoucherList';
import CancellationHistoryList from './cancellationHistory/CancellationHistoryList';
import LossAbsorbedList from './giftcardlossabsorbed/LossAbsorbedList';
import PpsMoneyManagement from './layout/PpsMoneyManagement';
import RewardsEwalletHistoryFetch from './layout/RewardsEwalletHistoryFetch';
import ConstantsKeyValueDashboard from './layout/ConstantsKeyValueDashboard';
import FraudReview from './layout/FraudReview';
import UpdatePaymentReference from './layout/UpdatePaymentReference';
import HybridMortgageUpdate from './layout/HybridMortgageUpdate';
import ManageLinkedAccount from './layout/ManageLinkedAccount';
import UserSessionInfo from './layout/UserSessionInfo';
import AutoSaveDashboard from './layout/AutoSaveDashboard';
import BoostAward from './layout/BoostAward';
import TransferReferrals from './layout/TransferReferrals';
import ChallengeDashboard from './layout/ChallengeDashboard';
import MastercardAnywhereDashboard from './layout/MastercardAnywhereDashboard';
import MastercardAnywhereDetail from './layout/MastercardAnywhereDetail';
import MastercardAnywhereAccessDashboard from './layout/MastercardAnywhereAccessDashboard';
import LoadMoneyPpsSandboxAccount from './layout/LoadMoneyPpsSandboxAccount';
import AdminEwalletRegistration from './layout/AdminEwalletRegistration';
import UpdateGiftCardTransaction from './layout/UpdateGiftCardTransaction';
import ShopGridManager from './layout/ShopGridManager';
import NewUserBoostDashboard from './layout/NewUserBoostDashboard';

export default [
<Route exact path="/configuration" render={() => <Configuration />} />,
<Route exact path="/newUserBoostDashboard" render={()=><NewUserBoostDashboard/>}/>,
<Route exact path="/register" noLayout render={()=><Register/>}/>,
<Route exact path="/dashboard" render={()=><Dashboard/>}/>,
<Route exact path="/userDetail" render={()=><UserDetail/>}/>,
<Route exact path="/userInflightDetails" render={()=><UserInflightDetails/>}/>,
<Route exact path="/mortgageKycDebug" render={()=><MortgageKycDebug/>}/>,
<Route exact path="/accountClosure" render={()=><AccountClosure/>}/>,
<Route exact path="/promoCodeRecords" render={()=><PromoCodeRecords/>}/>,
<Route exact path="/giftCardDashboard" render={()=><GiftCardDashboard/>}/>,
<Route exact path="/homeValuation" render={()=><HomeValuation/>}/>,
<Route exact path="/applyPromoReferralCode" render={()=><ApplyPromoReferralCode/>}/>,
<Route exact path="/transferRewardAmount" render={()=><TransferRewardAmount/>}/>,
<Route exact path="/updatePayToLender" render={()=><UpadtePayToLender/>}/>,
<Route exact path="/updateDirectDebit" render={()=><UpadteDirectDebit/>}/>,
<Route exact path="/addressAndCreditReport" render={()=><AddressAndCreditReport/>}/>,
<Route exact path="/masterToEwalletFailure" render={()=><MasterToEwalletFailure/>}/>,
<Route exact path="/pullCreditFile" render={()=><PullCreditFile/>}/>,
<Route exact path="/generateBrokerReport" render={()=><GenerateBrokerReport/>}/>,
<Route exact path="/pnNotifier" render={()=><PNNotifier/>}/>,
<Route exact path="/remortgageLetter" render={()=><RemortgageLetter/>}/>,
<Route exact path="/redisCacheCleaner" render={()=><RedisCacheCleaner/>}/>,
<Route exact path="/updatePendingTask" render={()=><UpdatePendingTask/>}/>,
<Route exact path="/updateUserPendingAction" render={()=><UpdateUserPendingAction/>}/>,
<Route exact path="/getVerificationLink" render={()=><GetVerificationLink/>}/>,
<Route exact path="/updateGiftCardBlackList" render={()=><UpdateGiftCardBlacklist/>}/>,
<Route exact path="/ppsPayee" render={()=><PpsPayee/>}/>,
<Route exact path="/deleteUser" render={()=><DeleteUser/>}/>,
<Route exact path="/manageUser" render={()=><ManageUser/>}/>,
<Route exact path="/removeUserFromSuppressionList" render={()=><RemoveUserFromSuppressionList/>}/>,
<Route exact path="/removePinForUser" render={()=><RemovePinForUser/>}/>,
<Route exact path="/forcedLogoutUser" render={()=><ForcedLogutUser/>}/>,
<Route exact path="/userMortgageData" render={()=><UserMortgageData/>}/>,
<Route exact path="/changeGiftCardState" render={()=><ChangeGiftCardState/>}/>,
<Route exact path="/createPromocode" render={()=><CreatePromocode/>}/>,
<Route exact path="/accountRestore" render={()=><AccountRestore/>}/>,
<Route exact path="/truelayerSyncFailureMonitor" render={()=><TrueLayerSyncFailureMonitor/>}/>,
<Route exact path="/dupeAccountCheck" render={()=><DupeAccountCheck/>}/>,
<Route exact path="/amlChecks" render={()=><AmlChecks/>}/>,
<Route exact path="/deleteVrpConsent" render={()=><DeleteVrpConsent/>}/>,
<Route exact path="/superChargedCalculator" render={()=><SuperchargedCalculator/>}/>,
<Route exact path="/giftCardTransactionDetailsPage" render={()=><GiftCardTransactionDetailsPage/>}/>,
<Route exact path="/vdxDashboard" render={()=><VdxDashboard/>}/>,
<Route exact path="/partnerizeUserActivity" render={()=><PartnerizeUserActivity/>}/>,
<Route exact path="/awinUserActivity" render={()=><AwinUserActivity/>}/>,
<Route exact path="/affiliateUserActivity" render={()=><AffiliateUserActivity/>}/>,
<Route exact path="/featureFlagDashboard" render={()=><FeatureFlagDashboard/>}/>,
<Route exact path="/paymentProviderDashboard" render={()=><PaymentProviderDashboard/>}/>,
<Route exact path="/updateUser" render={()=><UpdateUser/>}/>,
<Route exact path="/moveAccountRewards" render={()=><MoveAccountRewards/>}/>,
<Route exact path="/removeBiometricsForUser" render={()=><RemoveBiometricsForUser/>}/>,
<Route exact path="/manageUserPasskeys" render={()=><ManageUserPasskeys/>}/>,
<Route exact path="/manageDeviceSignatures" render={()=><ManageDeviceSignatures/>}/>,
<Route exact path="/masterToUserWalletDashboard" render={()=><MasterToUserWalletDashboard/>}/>,
<Route exact path="/natwestTransfer" render={()=><NatwestTransferDashboard/>}/>,
<Route exact path="/tilloFloat" render={()=><TilloFloatDashboard/>}/>,
<Route exact path="/natwestInternalTransfer" render={()=><NatwestInternalTransferDashboard/>}/>,
<Route exact path="/neocurrencyTopup" render={()=><NeoCurrencyTopupDashboard/>}/>,
<Route exact path="/referralConfig" render={()=><ReferralConfig/>}/>,
<Route exact path="/referralUserTracking" render={()=><ReferralUserTracking/>}/>,
<Route exact path="/referralFraudReview" render={()=><ReferralFraudReview/>}/>,
<Route exact path="/brandHaircutConfig" render={()=><BrandHaircutConfig/>}/>,
<Route exact path="/giftCardBrands" render={()=><GiftCardBrands/>}/>,
<Route exact path="/giftCardBrandManagement" render={()=><GiftCardBrandManagement/>}/>,
<Route exact path="/promoBannerConfig" render={()=><PromoBannerConfig/>}/>,
<Route exact path="/referralPromoBannerConfig" render={()=><ReferralPromoBannerConfig/>}/>,
<Route exact path="/prizeDrawConfig" render={()=><PrizeDrawConfig/>}/>,
<Route exact path="/vdxMerchants" render={()=><VdxMerchantsDashboard/>}/>,
<Route exact path="/partnerizeBrands" render={()=><PartnerizeBrandsDashboard/>}/>,
<Route exact path="/awinBrands" render={()=><AwinBrandsDashboard/>}/>,
<Route exact path="/vdxBrandUrlTest" render={()=><VdxBrandUrlTest/>}/>,
<Route exact path="/vdxClaimForm" render={()=><VdxClaimForm/>}/>,
<Route exact path="/cancelVoucher" render={()=><CancelVoucherList/>}/>,
<Route exact path="/cancellationHistory" render={()=><CancellationHistoryList/>}/>,
<Route exact path="/giftcardlossabsorbed" render={()=><LossAbsorbedList/>}/>,
<Route exact path="/ppsMoneyManagement" render={()=><PpsMoneyManagement/>}/>,
<Route exact path="/rewardsEwalletHistoryFetch" render={()=><RewardsEwalletHistoryFetch/>}/>,
<Route exact path="/constantsKeyValueDashboard" render={()=><ConstantsKeyValueDashboard/>}/>,
<Route exact path="/fraudReview" render={()=><FraudReview/>}/>,
<Route exact path="/updatePaymentReference" render={()=><UpdatePaymentReference/>}/>,
<Route exact path="/hybridMortgageUpdate" render={()=><HybridMortgageUpdate/>}/>,
<Route exact path="/manageLinkedAccount" render={()=><ManageLinkedAccount/>}/>,
<Route exact path="/userSessionInfo" render={()=><UserSessionInfo/>}/>,
<Route exact path="/autoSaveDashboard" render={()=><AutoSaveDashboard/>}/>,
<Route exact path="/boostAward" render={()=><BoostAward/>}/>,
<Route exact path="/transferReferrals" render={()=><TransferReferrals/>}/>,
<Route exact path="/challengeDashboard" render={()=><ChallengeDashboard/>}/>,
<Route exact path="/mastercardAnywhere" render={()=><MastercardAnywhereDashboard/>}/>,
<Route path="/mastercardAnywhere/:id" render={()=><MastercardAnywhereDetail/>}/>,
<Route exact path="/mastercardAnywhereAccess" render={()=><MastercardAnywhereAccessDashboard/>}/>,
<Route exact path="/loadMoneyPpsSandboxAccount" render={()=><LoadMoneyPpsSandboxAccount/>}/>,
<Route exact path="/giftCardTopupsDashboard" render={()=><GiftCardTopupsDashboard/>}/>,
<Route exact path="/adminEwalletRegistration" render={()=><AdminEwalletRegistration/>}/>,
<Route exact path="/updateGiftCardTransaction" render={()=><UpdateGiftCardTransaction/>}/>,
<Route exact path="/shopGridCategories" render={()=><ShopGridManager/>}/>,
<Route exact path="/brandCatalogVdxMerchants" render={()=><BrandCatalogVdxMerchants/>}/>,
<Route exact path="/brandCatalogTilloHealth" render={()=><BrandCatalogTilloHealth/>}/>,
<Route exact path="/brandCatalogTilloOverride" render={()=><BrandCatalogTilloOverride/>}/>,
];
